// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer_3pmhh","page":"page_1P1L2","scroll":"scroll_PeZxC","scroll_bar":"scroll_bar_w0yIC","scroll_next":"scroll_next_3y5oA","scroll_prev":"scroll_prev_3WaEa"};